import {
    QuiltySubscriptionPlan,
    QuiltySubscriptionPlanType,
    QUILTY_SUBCSCRIPTION_PLANS,
} from "../types";
import {
    SUBCRIPTION_PLANS,
    SubscriptionPlan,
    SubscriptionPlanType,
} from "../types/models/subscription";

export const getSubscriptionPlan = (planType: SubscriptionPlanType): SubscriptionPlan | null => {
    for (const plan of SUBCRIPTION_PLANS) {
        if (plan.plan === planType) {
            return plan;
        }
    }

    return null;
};

export const getQuiltySubscriptionPlan = (
    planType: QuiltySubscriptionPlanType,
): QuiltySubscriptionPlan | null => {
    for (const plan of QUILTY_SUBCSCRIPTION_PLANS) {
        if (plan.plan === planType) {
            return plan;
        }
    }

    return null;
};
